var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStupaidVerifiedBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6228 7.42927L15.4667 6.0866C15.2457 5.83166 15.0672 5.35578 15.0672 5.01587V3.57123C15.0672 2.67046 14.3276 1.93114 13.4266 1.93114H11.9815C11.65 1.93114 11.1655 1.75269 10.9104 1.53174L9.56736 0.376031C8.98082 -0.125344 8.02027 -0.125344 7.42523 0.376031L6.09062 1.54024C5.8356 1.75269 5.35107 1.93114 5.01955 1.93114H3.54896C2.64791 1.93114 1.90836 2.67046 1.90836 3.57123V5.02437C1.90836 5.35578 1.72985 5.83166 1.51734 6.0866L0.369772 7.43777C-0.123257 8.02412 -0.123257 8.97589 0.369772 9.56224L1.51734 10.9134C1.72985 11.1683 1.90836 11.6442 1.90836 11.9756V13.4288C1.90836 14.3295 2.64791 15.0689 3.54896 15.0689H5.01955C5.35107 15.0689 5.8356 15.2473 6.09062 15.4683L7.43373 16.624C8.02027 17.1253 8.98082 17.1253 9.57586 16.624L10.9189 15.4683C11.174 15.2473 11.65 15.0689 11.99 15.0689H13.4351C14.3361 15.0689 15.0757 14.3295 15.0757 13.4288V11.9841C15.0757 11.6527 15.2542 11.1683 15.4752 10.9134L16.6313 9.57074C17.1243 8.98438 17.1243 8.01562 16.6228 7.42927Z",
    fill: "#AE7BEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79688 9.07741L7.76382 10.8161C8.68939 8.53711 9.46022 7.53709 11.206 6.17969",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStupaidVerifiedBadge);
export default __webpack_public_path__ + "static/media/stupaid-verified-badge.49f9b7f36f5373d39dfd94478ae49c00.svg";
export { ForwardRef as ReactComponent };